import api from "./api";
import { ApiResponse, AdminNotificationPreferences } from "../types";

class AdminNotificationService {
  // Get admin notification preferences
  async getPreferences(): Promise<AdminNotificationPreferences> {
    const response = await api.get<ApiResponse<AdminNotificationPreferences>>(
      "/admin/notifications/preferences"
    );
    return response.data.data!;
  }

  // Update admin notification preferences
  async updatePreferences(
    preferences: Partial<AdminNotificationPreferences>
  ): Promise<AdminNotificationPreferences> {
    const response = await api.put<ApiResponse<AdminNotificationPreferences>>(
      "/admin/notifications/preferences",
      preferences
    );
    return response.data.data!;
  }

  // Reset admin notification preferences to defaults
  async resetPreferences(): Promise<AdminNotificationPreferences> {
    const response = await api.post<ApiResponse<AdminNotificationPreferences>>(
      "/admin/notifications/preferences/reset"
    );
    return response.data.data!;
  }

  // Send test notification
  async sendTestNotification(type: "newRSVP" | "rsvpUpdate"): Promise<void> {
    await api.post<ApiResponse>("/admin/notifications/test", { type });
  }
}

export const adminNotificationService = new AdminNotificationService();
